module.exports = __webpack_public_path__ + "static/img/download.9452e79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo/download.png
// module id = /POV
// module chunks = 36